import styled from 'styled-components';
export const GinStepPropertyConditionsContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 0;
  width: fit-content;
  height: fit-content;
  line-height: 1;
`;
export const GinStepCheckboxContentContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const GinStepCheckboxContentContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  align-items: left;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  max-width: 16px;
`;
export const GinStepCheckboxContentBody = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  display: flex;
  align-items: center;
  gap: 1px;
`;
